/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon24Solid = forwardRef('MediaUiASkipBackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7 13.532V18.5a1.5 1.5 0 1 1-3 0v-13a1.5 1.5 0 0 1 3 0v4.968l10.335-6.335C18.503 3.418 20 4.257 20 5.625v12.75c0 1.367-1.498 2.207-2.665 1.492L7 13.532Z" })));
});
